import React, { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import AuthShell, { Field, inputCls, SubmitBtn } from "../../components/AuthShell";
import api from "../../lib/api";

const ResetPassword = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (pw !== pw2) return setErr("Passwords do not match");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { reset_token: token, new_password: pw });
      setDone(true);
      setTimeout(() => navigate("/login"), 1800);
    } catch (e) {
      setErr(e?.response?.data?.detail || "Reset failed");
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Set a new password" subtitle="Choose a strong password for your account"
      footer={<Link to="/login" className="text-indigo-600 font-medium hover:underline">Back to sign in</Link>}>
      {done ? (
        <div className="text-center">
          <div className="w-14 h-14 rounded-full bg-emerald-50 text-emerald-500 flex items-center justify-center mx-auto"><CheckCircle2 size={26} /></div>
          <p className="mt-4 text-gray-700">Password updated. Redirecting to sign in…</p>
        </div>
      ) : (
        <form onSubmit={submit}>
          {err && <div className="mb-4 text-sm text-rose-600 bg-rose-50 border border-rose-100 rounded-lg px-3 py-2">{err}</div>}
          {!token && <div className="mb-4 text-sm text-amber-700 bg-amber-50 border border-amber-100 rounded-lg px-3 py-2">Missing reset token. Request a new link.</div>}
          <Field label="New password"><input type="password" required minLength={6} value={pw} onChange={(e) => setPw(e.target.value)} className={inputCls} /></Field>
          <Field label="Confirm password"><input type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)} className={inputCls} /></Field>
          <SubmitBtn loading={loading} disabled={!token}>Update password</SubmitBtn>
        </form>
      )}
    </AuthShell>
  );
};

export default ResetPassword;
